import { REGEX_CITY_NAME_FORBIDDEN_SYMBOLS } from 'clickNgo/configs/regex'

export const checkAsianCityName = (value: string) => {
  if (REGEX_CITY_NAME_FORBIDDEN_SYMBOLS.test(value) || value.length < 1) {
    return 'The field City has an incorrect value'
  }
  return ''
}
